import { styled } from 'shared/Houston';

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: 1.6fr 0.3fr 0.28fr;
  border: 1px solid ${({ theme }) => theme.neutralColor.high.medium};
  padding: ${({ theme }) => theme.spacing.xxxs};
  justify-content: center;
  border-radius: ${({ theme }) => theme.border.radius.xs};
  align-items: center;
  background-color: ${({ theme }) => theme.neutralColor.high.pure};
`;
